/*
 * @Author:
 * @LastEditTime: 2025-09-02 16:06:27
 * @Description:
 */
import WizIotManagementRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'wiz-iot-management',
  title: '物联网系统',
  version: '0.1.160',
  description: '物联网系统',
  routes: WizIotManagementRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'IOTDeviceTemplateApi',
      'DataCategoryApi',
      'IOTDeviceApi',
      'IOTDeviceProtocolInstanceApi',
      'DataCategoryApi',
      'Tag3DPositionApi',
      'Tag3DPositionImgApi',
    ],
  },
  config: {
    apiConfig: {
      DEVASP_SERVER: 'http://devaspnetcore01.wiz.top:7500',
      DEVASP_TOKEN: '2eb9f4b8-5cb3-4fe4-a2fc-d40c3c8a7f31',
    },
    modelSetting: {
      cloundRenderLoadMode: 'video',
      cloudServer: 'ws://renderapi.wiz.top:8082',
      cloudProtocol: 'ws',
      modelFileList: [
        {
          filePath: 'data://../apps/BL/models/bl.pr',
          fileName: '博罗.pr',
        },
      ],
    },
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
